import React from "react";
import styles from "./WorkDays.module.scss";

import { Peoples } from "modules/orders-manage/details/Peoples";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { ProvisionalCalendarMark } from "./ProvisionalCalendarMark";

export const WorkDays: React.FC<WorkDaysProps> = ({ days, hours, users, provisional }) => {
    // const hours = Constants.workDayHours * days;

    return (
        <div className={`work-days ${styles.workDays}`}>
            <span>
                <GeneralIcon type={"general-clock"} />
                &nbsp;{days}&nbsp;({hours} ч)
                {provisional && <ProvisionalCalendarMark />}
            </span>

            <span>
                <Peoples count={users} />
            </span>
        </div>
    );
};

interface WorkDaysProps {
    days: number;
    hours: number;
    users: number;
    /** Нормы по предварительному календарю (ТК РФ) */
    provisional?: boolean;
}
